import { render } from "./SportSelection.vue?vue&type=template&id=5ef82922&scoped=true"
import script from "./SportSelection.vue?vue&type=script&lang=js"
export * from "./SportSelection.vue?vue&type=script&lang=js"

import "./SportSelection.vue?vue&type=style&index=0&id=5ef82922&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef82922"]])

export default __exports__